module.exports = __webpack_public_path__ + "img/banner.e50be743.png";